import { useEffect, useState } from 'react';
import api from '../api';
import MarkdownEditor from '../components/MarkdownEditor';

export default function AdminKnowledge() {
  const [cats, setCats] = useState([]);
  const [items, setItems] = useState([]);
  const [catForm, setCatForm] = useState({ name:'', slug:'', description:'', order:100, parentId:'' });
  const [entryForm, setEntryForm] = useState({ title:'', slug:'', type:'article', status:'published', excerpt:'', content:'', tags:'', attachments:'', categoryId:'', visibilityRoles:'member,mentor,moderator,admin,owner' });
  const [editingCat, setEditingCat] = useState(null);
  const [editingEntry, setEditingEntry] = useState(null);

  const load = async () => {
    const c = await api.get('/kb/admin/categories').then(r => r.data.items || []);
    setCats(c);
    const i = await api.get('/kb/admin/entries').then(r => r.data.items || []);
    setItems(i);
  };
  useEffect(()=>{ load(); }, []);

  const saveCat = async (e) => {
    e.preventDefault();
    const payload = { ...catForm, parentId: catForm.parentId || null };
    if (editingCat) await api.put(`/kb/admin/categories/${editingCat.id}`, payload);
    else await api.post('/kb/admin/categories', payload);
    setCatForm({ name:'', slug:'', description:'', order:100, parentId:'' });
    setEditingCat(null);
    await load();
  };
  const editCat = (c) => { setEditingCat(c); setCatForm({ name:c.name, slug:c.slug, description:c.description||'', order:c.order||100, parentId:c.parentId||'' }); };
  const delCat = async (c) => { if (!confirm('Kategorie löschen?')) return; await api.delete(`/kb/admin/categories/${c.id}`); await load(); };

  const saveEntry = async (e) => {
    e.preventDefault();
    const payload = {
      ...entryForm,
      tags: entryForm.tags ? entryForm.tags.split(',').map(s=>s.trim()).filter(Boolean) : [],
      attachments: entryForm.attachments ? entryForm.attachments.split('\n').map(l=>{
        const [title, url] = l.split('|').map(s=>s && s.trim());
        return url ? { title: title || url, url } : null;
      }).filter(Boolean) : [],
      categoryId: entryForm.categoryId || null,
      visibilityRoles: entryForm.visibilityRoles ? entryForm.visibilityRoles.split(',').map(s=>s.trim()).filter(Boolean) : [],
    };
    if (editingEntry) await api.put(`/kb/admin/entries/${editingEntry.id}`, payload);
    else await api.post('/kb/admin/entries', payload);
  setEntryForm({ title:'', slug:'', type:'article', status:'published', excerpt:'', content:'', tags:'', attachments:'', categoryId:'', visibilityRoles:'member,mentor,moderator,admin,owner' });
    setEditingEntry(null);
    await load();
  };
  const editEntry = (it) => {
    setEditingEntry(it);
    setEntryForm({
      title: it.title, slug: it.slug, type: it.type, status: it.status, excerpt: it.excerpt||'', content: it.content||'',
      tags: Array.isArray(it.tags) ? it.tags.join(', ') : '',
      attachments: Array.isArray(it.attachments) ? it.attachments.map(a=>`${a.title||a.url}|${a.url}`).join('\n') : '',
      categoryId: it.categoryId || '',
      visibilityRoles: Array.isArray(it.visibilityRoles) ? it.visibilityRoles.join(',') : 'member,mentor,moderator,admin,owner'
    });
  };
  const delEntry = async (it) => { if (!confirm('Eintrag löschen?')) return; await api.delete(`/kb/admin/entries/${it.id}`); await load(); };

  return (
    <div className="home-page">
      <section style={{ width:'100vw', margin:0, padding:0, position:'relative', left:'-120px' }}>
        <h2 className="hero-title" style={{ textAlign: 'center', margin:'0 0 8px' }}>Wissensdatenbank verwalten</h2>
        <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign:'center', maxWidth:760 }}>Kategorien und Einträge anlegen, bearbeiten und löschen.</p>
      </section>
      <section style={{ width:'100%', maxWidth:1100, margin:'0 auto', padding:'0 16px 40px 16px', color:'#fff' }}>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 }}>
          <div>
            <h3 style={{ margin:'8px 0' }}>Kategorien</h3>
            <form onSubmit={saveCat} style={{ background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:10, padding:12 }}>
              <div style={{ display:'grid', gap:8 }}>
                <label>
                  <div style={{ fontSize:12, color:'#bbb' }}>Name</div>
                  <input required value={catForm.name} onChange={e=>setCatForm({...catForm, name:e.target.value})} />
                </label>
                <label>
                  <div style={{ fontSize:12, color:'#bbb' }}>Slug</div>
                  <input required value={catForm.slug} onChange={e=>setCatForm({...catForm, slug:e.target.value})} placeholder="z. B. allgemeines" />
                </label>
                <label>
                  <div style={{ fontSize:12, color:'#bbb' }}>Beschreibung</div>
                  <textarea value={catForm.description} onChange={e=>setCatForm({...catForm, description:e.target.value})} />
                </label>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8 }}>
                  <label>
                    <div style={{ fontSize:12, color:'#bbb' }}>Reihenfolge</div>
                    <input type="number" value={catForm.order} onChange={e=>setCatForm({...catForm, order:parseInt(e.target.value||'0')})} />
                  </label>
                  <label>
                    <div style={{ fontSize:12, color:'#bbb' }}>Überkategorie</div>
                    <select value={catForm.parentId} onChange={e=>setCatForm({...catForm, parentId: e.target.value})}>
                      <option value="">(keine)</option>
                      {cats.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                    </select>
                  </label>
                </div>
                <div>
                  <button type="submit">{editingCat ? 'Kategorie aktualisieren' : 'Kategorie erstellen'}</button>
                  {editingCat && <button type="button" onClick={()=>{ setEditingCat(null); setCatForm({ name:'', slug:'', description:'', order:100, parentId:'' }); }} style={{ marginLeft:8 }}>Abbrechen</button>}
                </div>
              </div>
            </form>
            <ul style={{ marginTop:8 }}>
              {cats.map(c => (
                <li key={c.id} style={{ background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:10, padding:12, marginBottom:10 }}>
                  <b>{c.name}</b> <span style={{ color:'#bbb' }}>· {c.slug}</span>
                  <div style={{ marginTop:6 }}>
                    <button onClick={()=>editCat(c)}>Bearbeiten</button>
                    <button onClick={()=>delCat(c)} style={{ marginLeft:8, color:'red' }}>Löschen</button>
                  </div>
                </li>
              ))}
              {cats.length===0 && <li style={{ color:'#aaa', fontSize:12 }}>Keine Kategorien vorhanden.</li>}
            </ul>
          </div>
          <div>
            <h3 style={{ margin:'8px 0' }}>Einträge</h3>
            <form onSubmit={saveEntry} style={{ background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:10, padding:12 }}>
              <div style={{ display:'grid', gap:8 }}>
                <label>
                  <div style={{ fontSize:12, color:'#bbb' }}>Titel</div>
                  <input required value={entryForm.title} onChange={e=>setEntryForm({...entryForm, title:e.target.value})} />
                </label>
                <label>
                  <div style={{ fontSize:12, color:'#bbb' }}>Slug</div>
                  <input required value={entryForm.slug} onChange={e=>setEntryForm({...entryForm, slug:e.target.value})} placeholder="z. B. konto-zuruecksetzen" />
                </label>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8 }}>
                  <label>
                    <div style={{ fontSize:12, color:'#bbb' }}>Typ</div>
                    <select value={entryForm.type} onChange={e=>setEntryForm({...entryForm, type:e.target.value})}>
                      <option value="article">Artikel</option>
                      <option value="faq">FAQ</option>
                    </select>
                  </label>
                  <label>
                    <div style={{ fontSize:12, color:'#bbb' }}>Status</div>
                    <select value={entryForm.status} onChange={e=>setEntryForm({...entryForm, status:e.target.value})}>
                      <option value="published">veröffentlicht</option>
                      <option value="draft">Entwurf</option>
                    </select>
                  </label>
                </div>
                <label>
                  <div style={{ fontSize:12, color:'#bbb' }}>Kategorie</div>
                  <select value={entryForm.categoryId} onChange={e=>setEntryForm({...entryForm, categoryId: e.target.value})}>
                    <option value="">(keine)</option>
                    {cats.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                  </select>
                </label>
                <label>
                  <div style={{ fontSize:12, color:'#bbb' }}>Tags (Komma-getrennt)</div>
                  <input value={entryForm.tags} onChange={e=>setEntryForm({...entryForm, tags:e.target.value})} placeholder="konto, passwort, anmeldung" />
                </label>
                {entryForm.type === 'article' && (
                  <label>
                    <div style={{ fontSize:12, color:'#bbb' }}>Anhänge/Links (pro Zeile: Titel|URL)</div>
                    <textarea value={entryForm.attachments} onChange={e=>setEntryForm({...entryForm, attachments: e.target.value})} placeholder={'Kurzanleitung PDF|/uploads/files/handbuch.pdf\nOffizielle Doku|https://example.org'} />
                  </label>
                )}
                <label>
                  <div style={{ fontSize:12, color:'#bbb' }}>Sichtbare Rollen (Komma-getrennt)</div>
                  <input value={entryForm.visibilityRoles} onChange={e=>setEntryForm({...entryForm, visibilityRoles:e.target.value})} placeholder="member,mentor,moderator,admin,owner" />
                </label>
                <label>
                  <div style={{ fontSize:12, color:'#bbb' }}>Kurzbeschreibung</div>
                  <textarea value={entryForm.excerpt} onChange={e=>setEntryForm({...entryForm, excerpt:e.target.value})} />
                </label>
                <label>
                  <div style={{ fontSize:12, color:'#bbb' }}>Inhalt</div>
                  <MarkdownEditor value={entryForm.content} onChange={(val)=>setEntryForm({...entryForm, content: val})} />
                </label>
                <div>
                  <button type="submit">{editingEntry ? 'Eintrag aktualisieren' : 'Eintrag erstellen'}</button>
                  {editingEntry && <button type="button" onClick={()=>{ setEditingEntry(null); setEntryForm({ title:'', slug:'', type:'article', status:'published', excerpt:'', content:'', tags:'', categoryId:'', visibilityRoles:'member,mentor,moderator,admin,owner' }); }} style={{ marginLeft:8 }}>Abbrechen</button>}
                </div>
              </div>
            </form>
            <ul style={{ marginTop:8 }}>
              {items.map(it => (
                <li key={it.id} style={{ background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:10, padding:12, marginBottom:10 }}>
                  <b>{it.title}</b> <span style={{ color:'#bbb' }}>· {it.slug}</span> <span style={{ color:'#bbb' }}>· {it.type}</span> <span style={{ color:'#bbb' }}>· {it.status}</span>
                  <div style={{ marginTop:6 }}>
                    <button onClick={()=>editEntry(it)}>Bearbeiten</button>
                    <button onClick={()=>delEntry(it)} style={{ marginLeft:8, color:'red' }}>Löschen</button>
                  </div>
                </li>
              ))}
              {items.length===0 && <li style={{ color:'#aaa', fontSize:12 }}>Keine Einträge vorhanden.</li>}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}
